<template>
    <v-card>
        <div class="popap-title">
            <h2>Change a meal</h2>
            <p>These meals are matched to follow your meal plan</p>
        </div>
        <v-card-text>
        <itemProductPopup v-for="product in viewListProduct" 
            :key="product.ID" 
            :product="product" 
            :popupProduct="popupProduct"
            :visible="showPopup" 
            :editOrder="true"
            @update:visible="$emit('update:visible', $event)"     
        />
        </v-card-text>
    </v-card>
</template>

<script>
import itemProductPopup from '../components/itemProductPopup.vue';

export default {
    name: 'PopupProduct', 
    props: ['showPopup'],       
    components: {
        itemProductPopup,
    },
    data() {
        return {
         
        }
    }, 
    emits: ['update:visible'], 
    computed: {
        popupProduct() {
            return this.$store.getters.popupProduct;
        },
        mainProducts() {
            return this.$store.getters.getMainProducts;
        },
        breakfastProducts() {
            return this.$store.getters.getBreakfastProducts;
        },
        snacksProducts() {
            return this.$store.getters.getSnacksProducts;
        },
        orderProducts() {
            return this.$store.getters.orderProducts;
        },
        viewListProduct() {
            
            if (this.popupProduct.category == 'main') {   
                return this.mainProducts.filter((product) => {                    
                    return !this.popupProduct.arrPr.some(item => product.ID === item.ID);
                }); 
            }

            if (this.popupProduct.category == 'breakfast') {
                return this.breakfastProducts.filter((product) => {
                    return !this.popupProduct.arrPr.some(item => product.ID === item.ID);
                });
            }

            if (this.popupProduct.category == 'snacks') {
                return this.snacksProducts.filter((product) => {
                    return !this.popupProduct.arrPr.some(item => product.ID === item.ID);
                });
                
            }
           
            return this.mainProducts;
        }
    },
    async beforeMount() {
       
    }
}
</script>
<style lang="stylus">
.popup-product {
    max-width: 600px;
    .v-overlay__content {
        border-radius: 10px;
        overflow: hidden;
    }
    .v-card {
        @media screen and (max-width: 550px) {
            padding-left: 0!important;
            padding-right: 0!important;
            padding-top: 0!important;
        }
    }
    .v-card-actions  {
        .v-btn__content {
            flex-direction: column;
            transform: scale(.6);
            letter-spacing: 0;
            transition-duration: .4s;

            &:hover {
                color: #fff;
                fill: #fff!important;

                path {
                    fill: #fff!important;
                }
            }
        }
        button {
            display: flex 
            padding-top: 5px
            &:hover .v-btn__content {
                color: #fff;
                fill: #fff!important;
                @media screen and (max-width: 767px) {
                    fill: #685bc7!important;
                    color: #685bc7;
                }

                path {
                    fill: #fff!important;
                    
                    @media screen and (max-width: 767px) {
                        fill: #685bc7!important;
                    }
                }
            }
            @media screen and (max-width: 550px) {
                padding-right: 0!important;
                max-width: 45px;
                min-width: 0;
                
            }
            .v-ripple__container,
            .v-btn__overlay, .v-btn__underlay {
                @media screen and (max-width: 767px) {
                    display: none!important;
                }
            }
            &.focus,
            &:hover,
            &:active {
                 @media screen and (max-width: 767px) {
                    background: none!important;
                }
                .v-btn__overlay {
                    @media screen and (max-width: 767px) {
                        background: none!important;
                        displa
                    }
                }
            }
        }
        
    }
    .popap-title {
        text-align: center;
        max-width: 280px;
        margin: -2rem auto 0;
        line-height: 1.3;
        p {
            margin-top: .3rem
        }
    }
}
::-webkit-scrollbar {
    width: 8px;
    background-color: #e1e6ef;
}
::-webkit-scrollbar-thumb {
    background-color: #685bc7;
    border-radius: 4em;
}
.product-wrap:last-child {
    border: none;
}
</style>
